export interface ErrorMessage {
    test: boolean;
    message: string;
}

declare global {
    // The type parameter must match the global Array<T> declaration to merge
    // with it, even though this augmentation never references it.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    interface Array<T> {
        countTestTrue(): number;
    }
}

Array.prototype.countTestTrue = function (): number {
    return this.filter((item: ErrorMessage) => item.test).length;
};